import { Check, Star } from 'lucide-react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { components } from '@/types/strapi';
import { SingleColumnPopupProps } from './SingleColumnPopup';
interface SingleColumnProductFeatureProps
	extends Omit<SingleColumnPopupProps, 'content'> {
	content: components['schemas']['PopupSingleColumnProductFeatureComponent'];
}
export const SingleColumnProductFeature = ({
	content,
}: SingleColumnProductFeatureProps) => {
	const ctaText = content?.button_?.text || 'Learn More';
	const featues = content?.features || [];

	return (
		<div className="product-feature">
			<div className="mt-2 space-y-4 pb-8">
				<div className="mb-2 rounded-md">
					<div className="mb-2 space-y-2">
						{featues.map((feat, ind) => (
							<div className="mb-3 flex items-start" key={ind}>
								<div className="mr-3 flex-shrink-0 rounded-full bg-blue-100 p-1.5">
									<Check className="h-4 w-4 text-blue-500" />
								</div>
								<span className="font-medium text-gray-800">
									{feat.text}
								</span>
							</div>
						))}
					</div>

					<div className="mb-2 flex flex-col">
						<div className="flex items-center">
							<div className="mr-2 flex">
								{[...Array(content?.rating || 1)].map(
									(_, i) => (
										<Star
											key={i}
											className="h-4 w-4 fill-current text-yellow-400"
										/>
									),
								)}
							</div>
							<span className="text-sm text-gray-700">
								({content?.review_count}+ reviews)
							</span>
						</div>
					</div>
				</div>
				<Link href={content?.button_?.URL || '/'}>
					<Button
						className="w-full py-6 text-base"
						variant={content?.button_?.variant}
						size="lg">
						{ctaText}
					</Button>
				</Link>

				<div className="mt-4 text-center text-xs text-gray-500">
					30-day money-back guarantee
				</div>
			</div>
		</div>
	);
};
